
























































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

// import menuList from "./data/menuList";

@Component({})
export default class PHeader extends Vue {
  @Getter('user/userInfo') private userInfo: any;
  @Getter('app/actionMenu') private actionMenu: any;
  @Getter('user/isLogin') private isLogin: any;
  @Getter('question/questionInfo') private questionInfo: any;
  private questionId: any = this.$route.query.questionId;
  private isShow: any = false;
  private avatar = require('@/assets/img/avatar.png');
  private powerType: any = 1;
  private workCodeInfo: any = {}; // 邀请码信息
  private isCoped: any = false; // 邀请码信息
  private dialogContent: any = ''; // 弹窗提示内容
  get settingData() {
    return this.$store.state.question.settingData;
  }
  get questionUrl() {
    let url: any = '';
    switch (this.questionInfo.questionType) {
      case 7:
        url = '/questionnaire/appoint.html';
        break;
      case 6:
        url = '/questionnaire/online.html';
        break;
      case 5:
        url = '/questionnaire/solitaire.html';
        break;
      case 4:
        url = '/questionnaire/form.html';
        break;
      case 2:
        url = '/questionnaire/exam.html';
        break;

      default:
        url = '/questionnaire/list.html';

        break;
    }
    console.log(this.questionInfo.questionType, url);
    return url;
  }
  get questionName() {
    let name = '';
    switch (this.questionInfo.questionType) {
      case 7:
        name = '在线预约';
        break;
      case 6:
        name = '在线收款';
        break;
      case 5:
        // name = '在线接龙';
        if (this.questionInfo.solitaireType === 1) {
          name = '打卡接龙';
        } else if (this.questionInfo.solitaireType === 2) {
          name = '团购接龙';
        } else if (this.questionInfo.solitaireType === 4) {
          name = '报名接龙';
        } else {
          name = '反馈接龙';
        }
        break;
      case 4:
        name = '报名表单';
        break;
      case 2:
        name = '考试测评';
        break;

      default:
        name = '问卷调研';

        break;
    }
    return name;
  }
  private listCount: any = {
    totalCount: 0,
    isReadCount: 0,
  };
  private handleToOnline() {
    window.open('https://affim.baidu.com/cps/chat?siteId=18784727&userId=34249595&siteToken=1609f3fbd3223bb649632b9565eebc23', '_blank');
  }

  private async created() {
    if (!this.questionInfo) {
      this.getWxQuestion();
    }
  }
  //   获取邀请码
  private getTeamWorkCode() {
    this.$apis
      .getTeamWorkCode({
        questionId: this.$tool.decrypt(this.questionId),
        powerType: this.powerType,
      })
      .then((res) => {
        // console.log(res.workCode, "邀请码");
        this.workCodeInfo = res;
      });
  }
  //   修改邀请码权限
  private changePowerType() {
    this.$apis.updateWorkType({
      workCodeId: this.workCodeInfo.teamWorkCodeId,
      powerType: this.powerType,
    });
  }

  // 复制邀请码
  private async copy() {
    // console.log(this.workCodeInfo.workCode, "邀请码");
    const oInput = document.createElement('textarea');

    oInput.value = `https://${window.location.host}/cooperation.html?work_code=${this.workCodeInfo.workCode}\n#相关项目: ${this.questionInfo.title || ''} \n 链接有效期: ${this.fun_date(0)}~${this.fun_date(7)}
    \n 请复制地址到电脑浏览器打开，登陆后，即可加入成功！
    `;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    document.execCommand('Copy'); // 执行浏览器复制命令
    oInput.remove();
    this.isCoped = true;
    setTimeout(() => {
      this.isCoped = false;
    }, 3000);
  }
  private fun_date(aa: any) {
    const pad = (val1: any) => {
      val1 = String(val1);
      while (val1.length < 2) {
        val1 = '0' + val1;
      }
      return val1;
    };
    const date1 = new Date();
    const date2 = new Date(date1);
    date2.setDate(date1.getDate() + aa);
    const time2 = pad(date2.getFullYear()) + pad(date2.getMonth() + 1) + pad(date2.getDate());
    return time2;
  }
  // 获取问卷内容
  private async getWxQuestion() {
    const data = await this.$apis.getWxQuestion({
      questionId: this.$tool.decrypt(this.questionId),
    });
    this.$store.dispatch('question/setQuestionInfo', data);
    this.questionInfo = data;
  }

  /**
   * 退出登录
   */
  private async handleLogout() {
    try {
      await this.$store.dispatch('user/logout');
      if (this.$route.name !== 'homeIndex') {
        this.$router.push('/home');
      }
      this.$message.success('退出成功');
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * 手机预览
   */
  private phonePreview() {
    // this.$store.dispatch('app/actionMenuName', null)
    // this.$router.push(
    //   `/questionnaire/preview.html?questionId=${encodeURIComponent(
    //     this.questionId
    //   )}`
    // )
    const { href } = this.$router.resolve({
      path: '/questionnaire/preview.html',
      query: { questionId: this.questionId },
    });
    window.open(href, '_blank');
  }
  /**
   * 发布
   */
  private releaseQuestionnaire() {
    this.$router.push({
      path: '/questionnaire/release.html',
      query: { questionId: this.questionId },
    });
  }

  /**
   * 去帮助中心
   */
  private toArticle() {
    // this.$router.push("/account.html");
    const { href } = this.$router.resolve({ name: 'article' });
    window.open(href, '_blank');
  }
  /**
   * 去账户资料
   */
  private goAccount() {
    // this.$router.push("/account.html");
    const { href } = this.$router.resolve({ name: 'account' });
    window.open(href, '_blank');
  }
  /**
   * 去我的收藏
   */
  private goCollection() {
    this.$router.push({ path: '/collection.html' });
  }
  /**
   * 去我的下载
   */
  private goToDownload() {
    this.$router.push('/myDownload.html');
    // const { href } = this.$router.resolve({ path: "/collection.html" });
    // window.open(href, "_blank");
  }
  /**
   * 去会员中心
   */
  private goMember() {
    // this.$router.push("/member.html");
    const { href } = this.$router.resolve({ name: 'memberIndex' });
    window.open(href, '_blank');
  }
  /**
   * 确认暂停问卷
   */
  private handleDeleteSubmit() {
    // this.showModalEdit = false;
    // this.$apis
    //   .getQuestionStatus({
    //     questionId: this.$tool.decrypt(this.questionId),
    //     status: 0,
    //   })
    //   .then((res) => {
    //     this.$router.push({
    //       path: "/questionnaire/add.html",
    //       query: { questionId: this.questionId },
    //     });
    //   });
  }
  private async handleSelect(key: any, keyPath: any) {
    // console.log(key);
    if (key === 'questionnaireEdit') {
      // console.log(this.questionInfo, "questionInfo");
      if (Number(this.questionInfo.status) !== 0) {
        let dialogContent: any = '';
        if (this.questionInfo.dataCount > 0) {
          dialogContent = `您的测评已收集 ${this.questionInfo.dataCount} 份数据，现在进行题目删改可能会影响已收集的数据。`;
        } else {
          dialogContent = `该问卷将暂停收集，您需要在修改完后再次发布问卷才可继续进行收集。`;
        }

        this.$InfoDialog({
          content: dialogContent,
          title: '修改提醒',
          width: '350px',
        })
          .then(() => {
            this.$apis
              .getQuestionStatus({
                questionId: this.$tool.decrypt(this.questionId),
                status: 0,
              })
              .then((res) => {
                this.$router.push({
                  path: '/questionnaire/add.html',
                  query: { questionId: this.questionId },
                });
              });
          })
          .catch(() => {
            console.log('取消', this.actionMenu);
          });
      } else {
        this.$router.push({
          path: '/questionnaire/add.html',
          query: { questionId: this.questionId },
        });
      }
    }
    if (key === 'questionnaireRelease') {
      // /questionnaire/add.html?questionId=${questionId}
      this.$router.push({
        path: '/questionnaire/release.html',
        query: { questionId: this.questionId },
      });
    }
    if (key === 'questionnaireReport') {
      // /questionnaire/add.html?questionId=${questionId}
      this.$router.push({
        path: '/questionnaire/report.html',
        query: { questionId: this.questionId },
      });
    }
    if (key === 'questionnaireSingleSetting') {
      // /questionnaire/add.html?questionId=${questionId}
      this.$router.push({
        path: '/questionnaire/setting.html',
        query: { questionId: this.questionId },
      });
    }
  }
}
